// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const sharePageToInviteGuests = (i) => `Teile diese Seite um deine Gäste einzuladen. Gäste können dann zu-/absagen etc.`